import styled from 'styled-components';
import {device} from 'styled/device';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalTitle = styled(Row)`
  justify-content: center;
  font-size: 28px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  color: #23262f;

  @media (max-width: ${device.mobileM}) {
    display: none;
  }
`;

export const ModalSmallText = styled(Row)`
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  color: #777e90;
  padding-bottom: 50px;
`;
export const ModalLabel = styled.div`
  font-size: 19px;
  font-weight: 600;
  color: #161643;
  /* padding-bottom: 50px; */
`;

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #eee;

  .modalLabel {
    font-size: 19px;
    font-weight: 600;
    color: #161643;
  }

  .modalValue {
    font-size: 16px;
    font-weight: 600;
    color: #161643;
  }
`;
